
import { IMiddlewareContext } from './middlewarePipeline'

import AuthService from '@/features/auth0/authService'
import { JOB_LIST_NAME } from '@/features/job/job.router'

const auth = new AuthService()

export const requireAuth = ({ to, next }: IMiddlewareContext) => {
  if (!auth.isAuthenticated()) {
    return auth.login()
  }
  if (to.path === '/') {
    return next({
      name: JOB_LIST_NAME
    })
  }
  return next()
}
